import { Component, EventEmitter, OnInit, Output, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ICheckboxConfig } from 'src/app/element-components/checkbox/checkbox.component';
import { IModal } from 'src/app/element-components/modal/modal.component';
import { normalizeURLParams } from 'src/app/models/util.model';
import { PortalService } from 'src/app/services/portal/portal.service';
import { SessionStorageKeyEnum, SessionStorageService } from 'src/app/services/session-storage/session-storage.service';
import { UserService } from 'src/app/services/user/user.service';
import { UserEventsTrackingService } from 'src/app/services/user-events-tracking/user-events-tracking.service';
import { ModalComponent } from '../../element-components/modal/modal.component';
import { CheckboxComponent } from '../../element-components/checkbox/checkbox.component';

export interface IQualifyingQuestionOption { id: string, label: string, isToShow: boolean }

@Component({
    selector: 'bt-qualifying-question',
    templateUrl: './qualifying-question.component.html',
    styleUrls: ['./qualifying-question.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ModalComponent, CheckboxComponent]
})
export class QualifyingQuestionComponent implements OnInit {
  private userService = inject(UserService);
  private portalService = inject(PortalService);
  private sessionStorageService = inject(SessionStorageService);
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);
  private userEventsTrackingService = inject(UserEventsTrackingService);

  public qualifyingQuestionModal: IModal = {
    id: 'qualifying_question_qualifying_question',
    title: 'What brought you to BindTuning today?',
    footer: true,
    header: true,
    isProcessing: false,
    processingLabel: '',
    width: 650,
    close: { action: () => this.remindMeLater() }
  }

  public possibleAnswers: ICheckboxConfig[] = [];

  @Output() closeModal: EventEmitter<void> = new EventEmitter();
  public close() {
    const normalizedParams = normalizeURLParams(this.activatedRoute.snapshot.queryParams)
    if(normalizedParams['ftl'] === 'true'){
      this.router.navigate([{ outlets: { modal: ["new-workspace"] } }], { queryParamsHandling: "merge" });
    }

    this.closeModal.emit();
  }

  async ngOnInit() {
    const portalQualifyingQuestion = await this.portalService.getPortalQualifyingQuestion();

    if (portalQualifyingQuestion.length > 0) {
      this.possibleAnswers = portalQualifyingQuestion.map(option => ({
        id: option.id,
        styleMode: 'dark',
        text: option.label,
        value: false,
      }));
    }
  }

  public saveQualifyingQuestion() {
    const selectedAnswers = this.possibleAnswers.filter(x => x.value);
    if (selectedAnswers.length === 0) {
      return;
    }

    // Update user profile with the selected answers
    this.userService.updateUserAccountQualifyingQuestion(selectedAnswers.map(x => x.id)).then(() => {
      this.userEventsTrackingService.addEvent_QualifyingQuestionAnswered(selectedAnswers.map(x => x.id));
      this.close();
    })
  }

  public isAnyAnswerSelected(): boolean {
    return this.possibleAnswers.some(x => x.value);
  }

  public remindMeLater() {
    this.userEventsTrackingService.addEvent_QualifyingQuestionRemindMeLater();
    this.sessionStorageService.save(
      this.sessionStorageService.getSessionStorageKey(SessionStorageKeyEnum.QualifyingQuestionRemindMeLater),
      true
    )
    this.close();
  }
}
